import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { Box, Typography } from '@mui/material';
import BaseSearchResults, {
  BaseSearchResultsProps,
} from 'pages/searchPage/baseSearchResults';
import BlockHeader from 'pages/components/blockHeader';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';

export type EntitySearchResultsProps = {
  amount: number;
  entityText: string;
  entityName: string;
} & BaseSearchResultsProps;

export default observer(function EntitySearchResults({
  results,
  amount,
  entityText,
  entityName,
  sort,
}: EntitySearchResultsProps) {
  const {
    spacings: { sp },
  } = useContext(UiContext);
  const { isLessLaptop } = useBooleanScreens();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: sp.s80 }}>
      <BlockHeader
        text={entityText}
        secondText={`${amount}`}
        buttonsNode={
          <Box
            sx={{
              width: 1,
              display: 'flex',
              justifyContent: isLessLaptop ? 'start' : 'end',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                bgcolor: 'custom.lightGrey',
                px: sp.s50,
                py: sp.s25,
                borderRadius: 100,
              }}
            >
              <Typography color="custom.textInactive" variant="f18">
                {entityName}
              </Typography>
            </Box>
          </Box>
        }
      ></BlockHeader>
      <BaseSearchResults sort={sort} results={results}></BaseSearchResults>
    </Box>
  );
});
